import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import AppRouter from 'router'

import 'antd/dist/antd.css'
import 'assets/scss/styles.scss'
import 'i18n/i18n'

import { Icon } from 'components'
import { CookiesProvider } from 'react-cookie'
import { AuthProvider } from 'context/authContext'

window.__BUILD_TIME__ = process.env.REACT_APP_BUILD_TIME

ReactDOM.render(
    <Suspense
        fallback={
            <div className='translation-buffer'>
                <Icon>loading</Icon>
            </div>
        }
    >
        <CookiesProvider>
            <React.StrictMode>
                <AuthProvider>
                    <AppRouter />
                </AuthProvider>
            </React.StrictMode>
        </CookiesProvider>
    </Suspense>,
    document.getElementById('root')
)
